import React from 'react';
import {
  Flex,
  FormControl,
  FormLabel,
  Select as SelectChakra,
  FormErrorMessage,
} from '@chakra-ui/react';
import { Controller } from 'react-hook-form';

interface Option {
  value: string;
  name?: string;
  text?: string;
}

interface SelectProps {
  name: string;
  control: any;
  label: string;
  options: Option[] | any[];
  placeholder: string;
  rules?: object;
  error?: any;
  defaultValue?: string;
  disabled?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>,value: string) => void;
}

const Select = ({
  name,
  control,
  label,
  options = [],
  placeholder,
  rules,
  error,
  defaultValue,
  disabled,
  onChange
}: SelectProps) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue={defaultValue}
      render={props => (
        <Flex
          flexDir={['column', 'row']}
          justify={['flex-start', 'space-between']}
          align={['flex-start', 'center']}
          mb="15px"
        >
          <FormLabel
            fontWeight={400}
            p={['0 0 5px 0', '0']}
            margin={['unset', '0 10px 0 0']}
            maxW={['100%', '500px']}
            w="100%"
            color="brand.fontColors.primary"
          >
            {label}
          </FormLabel>
          <FormControl width={['100%', 'calc(100% - 220px)']} isInvalid={error}>
            <SelectChakra
              key={name}
              size="lg"
              bg="#F4F8F8"
              border="1px solid #E3E9EA"
              borderRadius="0px"
              iconColor="white"
              iconSize="sm"
              color="brand.fontColors.select"
              placeholder={placeholder}
              maxW="400px"
              value={props.value || ''}
              onChange={e => {
                e.preventDefault();
                props.onChange(e.target.value);
                if (onChange) {
                  onChange(e, e.target.value);
                }
              }}
              onBlur={props.onBlur}
              fontSize={[16]}
              disabled={disabled}
            >
              {options.map(option => (
                <option
                  key={option.answerValue || option.code}
                  value={option.answerValue || option.code}
                >
                  {option.description || option.text}
                </option>
              ))}
            </SelectChakra>
            <FormErrorMessage>{error?.message}</FormErrorMessage>
          </FormControl>
        </Flex>
      )}
    />
  );
};

export default Select;
